import React from 'react'
import {Box, Grid,makeStyles,Paper,Typography} from '@material-ui/core';
import KenButton from '../../../components/KenButton/index';
import moment from 'moment';
//for upcoming adacemic programs
var today = moment();

const useStyles = makeStyles({
    table: {
      minWidth: 650,
    },
    item:{
      marginLeft:20,
      width:"100%"
    }
  });

export default function Card2(props) {
    const classes = useStyles();
    const { nodes,handleOpen } = props;
    const {Name,StartDate,EndDate,Fees} = props.nodes;
    const startDate = moment(nodes.StartDate);
    const endDate = moment(nodes.EndDate);
    
    const currentrow = {
        academicProgram: nodes.Name,
        department: "",
        endDate: nodes.EndDate,
        fees: nodes.Fees,
        institute: "",
        instituteId: nodes.ParentID,
        programId: nodes.Id,
        startDate:nodes.StartDate,
        RecordType:nodes.RecordType,
        AcademicYear:nodes.AcademicYear
    };
    return (
        <Box  className={classes.item}>
            <Grid container>
                <Grid item xs={2} sm={2} md={2}>
                    <Typography  color="initial"></Typography>
                </Grid>
                <Grid item xs={2} sm={2} md={2}>Start Date</Grid>
                <Grid item xs={2} sm={2} md={2}>End Date</Grid>
                <Grid item xs={2} sm={2} md={2}>Application Fee</Grid>
                <Grid item xs={2} sm={2} md={2}>Apply</Grid>
            </Grid>
            <Grid container>
                <Grid item xs={2} sm={2} md={2} p={1}>{Name}</Grid>
                <Grid item xs={2} sm={2} md={2}>{StartDate}</Grid>
                <Grid item xs={2} sm={2} md={2}>{EndDate}</Grid>
                <Grid item xs={2} sm={2} md={2}>{Fees}</Grid>
                <Grid item xs={2} sm={2} md={2}>
                {
                  today < startDate ? <KenButton label="Notify Me" variant="outlined" color="primary" onClick={(e)=>{handleOpen(currentrow)}}/>
                  : startDate <= today && today <= endDate  ? <KenButton label="Apply Now" variant="outlined" color="primary" onClick={(e)=>{handleOpen(currentrow)}}/>
                  :<KenButton label="Closed" variant="outlined" color="primary" disabled/>
                }
                </Grid>
            </Grid>
        </Box>
    )
}
